














































import Component from 'vue-class-component'
import Page from '~pages/ressort/_category/page/_page.vue'
import Eliteliga from '~components/content/widgets/listings/Eliteliga.vue'
import EliteligaTopWidget from '~components/content/widgets/listings/EliteligaTopWidget.vue'
import VNEliteliga from '~components/assets/VNEliteliga.vue'
import RessortTitle from '~components/content/widgets/listings/RessortTitle.vue'
import SoccerLeagueButtons from '~components/content/widgets/listings/SoccerLeagueButtons.vue'

import { ListingPageVariables } from '~base/mixins/listings'
import { ApolloOperationVariables } from '~base/common/types'

@Component<Page & EliteligaPage>({
  components: {
    Eliteliga,
    RessortTitle,
    VNEliteliga,
    EliteligaTopWidget,
    SoccerLeagueButtons,
  },
  apollo: {
    search: {
      query: require('~base/graphql/queries/FetchPostsForCategory.gql'),
      variables(): ListingPageVariables {
        return this.variables
      },
      prefetch({ route }: any): ListingPageVariables {
        return {
          first: this.perPage,
          page: parseInt(route.params.page || '0'),
          categories: ['eliteliga'],
        }
      },
      result({ data }) {
        this.gotResult(data)
      },
    },
    categories: {
      query: require('~base/graphql/queries/FetchCategory.gql'),
      prefetch(): ApolloOperationVariables {
        return {
          slug: ['eliteliga'],
        }
      },
      variables(): ApolloOperationVariables {
        return {
          slug: ['eliteliga'],
        }
      },
    },
  },
})
export default class EliteligaPage extends Page {
  protected settingsKey = `eliteliga`

  get variables(): ListingPageVariables {
    // console.log(`💣`, super.variables)
    return {
      first: this.perPage,
      page: parseInt(this.$route.params.page || '0'),
      categories: ['eliteliga'],
    }
  }

  get categoryName() {
    const [cat] = this.categories ? this.categories.nodes : []
    return cat ? cat.name : 'VOL.AT-Eliteliga'
  }

  get linkPrefix(): string {
    return `/ressort/eliteliga`
  }

  loadMoreData() {
    const { endCursor } = this.search.pageInfo
    if (endCursor) {
      this.after = endCursor
      this.nextPage()
    }
  }
}
